<template>
  <section v-if="form">
    <el-form ref="form" label-width="100px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">
      <el-form-item label="申请单位:">
        {{form.department.name}}
      </el-form-item>
      <el-form-item label="申请部门:">
        {{form.department.name}}
      </el-form-item>
      <el-form-item label="申请人:">
        <user-info :userData='form.creator'></user-info>
      </el-form-item>
      <el-form-item label="申请类别:">
        {{ form.type }}
      </el-form-item>
      <el-form-item label="申购时间:">
        {{ form.applyTime }}
      </el-form-item>
      <el-form-item label="用途及申请原因:" label-width="130px" class="full">
        {{ form.remark }}
      </el-form-item>
      <el-form-item class="full" label="物品明细:">
        <div class="material-table">
          <el-table :data="form.items" border>
            <el-table-column prop="name" label="物品名称">
            </el-table-column>
            <el-table-column prop="spec" label="规格型号">
            </el-table-column>
            <el-table-column prop="unitName"  width="50" align="center" label="单位">
            </el-table-column>

            <el-table-column prop="amount" width="80" align="center" label="数量">
            </el-table-column>
            <!-- <el-table-column prop="price" label="单价" align="center">
            </el-table-column>
            <el-table-column prop="totalPrice" label="金额" align="right">
            </el-table-column> -->
          </el-table>
        </div>
        <!-- <div class="total-price">
          总价：<span>{{ form.total }}</span> &nbsp;&nbsp;&nbsp;&nbsp;大写金额：<span>{{ getAmountInWords(form.total) }}</span>
        </div> -->
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {},
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getAmountInWords(total) {
        return util.convertCurrency(total)
      },
      getTime(t) {
        return util.getFormatDate(t, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/consumable/components/applyDetail.vue